import { Flex } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const PlusMoreAvatarsTextWrapper = styled(Flex)`
  border-radius: 50%;
  background-color: ${({ theme: { palette } }) => palette.hover};
  position: relative;
  z-index: 1;
  border: 2px solid ${({ theme: { palette } }) => palette.white};
`
